
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyDiesel as ObiEnergyDieselElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-diesel.js';
 
 
 

 
 export const ObiEnergyDiesel = createComponent({
   react: React,
   tagName: 'obi-energy-diesel',
   elementClass: ObiEnergyDieselElement,
   events: {
     
   }
  });
 
 